import LandingPage from './LandingPage.js';

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Pages/Home/LandingPage/index.js